import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ADESAO_PUBLICA.SALVAR_INFORMACOES_SOLICITANTE](context, objParam) {
		const { data } = await api.adesaoPublica.salvarInformacoesSolicitante(objParam)
		return data
	},

	async [actionTypes.ADESAO_PUBLICA.BUSCAR_INFORMACOES_SOLICITANTE](context, objParam) {
		const { data } = await api.adesaoPublica.buscarInformacoesSolicitante(objParam)
		return data
	},

	async [actionTypes.ADESAO_PUBLICA.BUSCAR_ITENS_POR_FILTRO]({ state }) {
		const { filtro, paginacao, idSolicitacaoAdesao } = state
		const { data } = await api.adesaoPublica.buscarItensPorFiltro(filtro, paginacao, idSolicitacaoAdesao)
		return data
	},

	async [actionTypes.ADESAO_PUBLICA.SALVAR_ITEM](context, objParam) {
		const { data } = await api.adesaoPublica.salvarItem(objParam)
		return data
	},

	async [actionTypes.ADESAO_PUBLICA.SALVAR_ANEXO_SOLICITANTE](context, objParam) {
		const formData = new FormData()
		formData.append('file', objParam.anexo)
		formData.append('idSolicitacaoAdesao', objParam.idSolicitacaoAdesao)
		formData.append('idAta', objParam.idAta)
		if (objParam.idTipoDocumento) {
			formData.append('idTipoDocumento', objParam.idTipoDocumento)
		}
		const { data } = await api.adesaoPublica.salvarAnexo(formData)
		return data
	},

	async [actionTypes.ADESAO_PUBLICA.BUSCAR_ANEXOS_POR_FILTRO]({ state }) {
		const { paginacao } = state.anexos
		const { idSolicitacaoAdesao } = state
		const { idAta } = state.filtro

		const { data } = await api.adesaoPublica.buscarAnexosPorFiltro({ idSolicitacaoAdesao, idAta }, paginacao)
		return data
	},

	async [actionTypes.ADESAO_PUBLICA.BAIXAR_ANEXO](context, objParam) {
		await api.adesaoPublica.baixarAnexo({
			idAnexo: objParam.idAnexo,
			tipoRegistroDocumento: objParam.tipoRegistroDocumento,
		})
	},

	async [actionTypes.ADESAO_PUBLICA.EXCLUIR_ANEXO](context, objParam) {
		const { data } = await api.adesaoPublica.excluirAnexo(objParam)
		return data
	},

	async [actionTypes.ADESAO_PUBLICA.ENVIAR_SOLICITACAO_ADESAO](context, objParam) {
		const { data } = await api.adesaoPublica.enviarSolicitacaoAdesao(objParam)
		return data
	},
}
